import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilterService } from '../filter.service';
import { GuestDetailsService } from './guest-details.service';
import { Router } from '@angular/router';
import { ToasterService } from 'src/app/toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types';
import { DataService } from '../data.service';

const GUEST_PROFILE_TYPE = 'guest';

@Component({
    selector: 'app-guest-details',
    templateUrl: './guest-details.component.html',
    styleUrls: ['./guest-details.component.css']
})

export class GuestDetailsComponent implements OnInit {
    public generalDetails: any;
    public generalInfo: any;
    public accountInfo: any;
    public statInfo: any = 'empty';
    public focus = false;
    public mobile = '';
    public mobileNumber: string;
    public id: string;
    public enteredNumber = false;
    public lastUsedDevice = '';
    public toggleableDetails = 'Order Details';
    public languageMap = {
        en: 'English',
        hi: 'Hindi',
        kn: 'Kannada',
        te: 'Telugu',
        ta: 'Tamil'
    };
    public guestDetailsToggleableHeaders: string[] = [
        'Order Details',
        'Wallet Transactions',
        'Referral Rewards'
    ];


    constructor(private route: ActivatedRoute,
        public filterService: FilterService,
        private toasterService: ToasterService,
        private guestDetailService: GuestDetailsService,
        private router: Router,
        private dataservice: DataService) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.mobile = params.mobile || this.route.snapshot.queryParamMap.get('phone');
            if (!this.mobile) {
                return;
            }
            this.getUser();
        });
        this.dataservice.updateSearchCount(this.mobile);
    }

    refreshPage(pageRefresh) {
        this.route.params.subscribe(params => {
            this.mobile = params.mobile || this.route.snapshot.queryParamMap.get('phone');
            if (!this.mobile) {
                return;
            }
            this.getUser();
        });
    }

    enteredMobile() {
        if (this.mobile.length > 0) {
            this.enteredNumber = true;
        } else {
            this.enteredNumber = false;
        }
    }

    getUser() {
        this.headersToggled('Order Details');
        const testMob = new RegExp('[0-9]{10}');
        if (!testMob.test(this.mobile)) {
            this.toasterService.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: `Please enter a valid 10-digit mobile number`,
            }));
        } else {
            this.router.navigate(['/guest/' + this.mobile]);
            this.generalInfo = null;
            this.accountInfo = null;
            this.guestDetailService.getGuestByMobile(this.mobile).subscribe((res: { roles: string[] }) => {
                this.toasterService.showToaster(new Toaster({
                    type: ToasterType.SUCCESS,
                    message: `User found`,
                }));
                this.generalDetails = res;
                this.generalDetails.dataFetched = true;
                this.accountInfo = res;
                this.accountInfo.dataFetched = true;
                this.mobileNumber = this.mobile;
                const guestProfile = this.generalDetails.profiles.filter(profile => profile.type === GUEST_PROFILE_TYPE)[0];
                this.id = guestProfile ? (guestProfile.id || guestProfile.profileId || guestProfile._id) : undefined;
                this.mobile = null;
                this.enteredNumber = false;
            },
                error => {
                    this.toasterService.showToaster(new Toaster({
                        type: ToasterType.WARNING,
                        message: `Unable to fetch this user. Please check the number again`,
                    }));
                    this.mobileNumber = this.mobile;
                    this.generalInfo = { dataFetched: false };
                    this.accountInfo = { dataFetched: false };
                });
        }
    }

    headersToggled(toggledHeader) {
        this.toggleableDetails = toggledHeader;
    }

    changeStatus(status) {
        this.mobile = this.mobileNumber;
        this.getUser();
        this.accountInfo = { ...this.accountInfo, status: status };
    }
}
